import React, { useState, useEffect } from "react";
import {
  Container,
  TextField,
  Button,
  Typography,
  Paper,
  Autocomplete,
  MenuItem,
  Select,
  Grid,
  Box,
} from "@mui/material";
import AddCircleOutlineOutlinedIcon from "@mui/icons-material/AddCircleOutlineOutlined";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import axios from "axios";
import { getAllPreference } from "../../services/getAllPreferences";
import { toCamelCaseForFirstChar } from "../../services/utilApis";
import { CustomAlert, showToastAlert } from "../../admin/components/CustomAlert";
import {
  addBlog,
  allCategories,
  getAllCategories,
  getBlogDetails,
} from "../../services/writerBlog";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate, useParams } from "react-router";
import { useSelector } from "react-redux";
import { Helmet } from "react-helmet-async";
import { useRef } from "react";
import { CategoryModal } from "../../blog/categoryModal";
import { Link } from "react-router-dom";
import { baseUrl } from "../../common/siteSettings";

const BlogForm = ({ type = "add" }) => {
  const navigate = useNavigate();
  const { blogid } = useParams();
  console.log("blogid:" + blogid);
  const [formData, setFormData] = useState({
    title: "",
    content: "",
    categories: [],
    tags: [],
    banner:""
  });
  const [blog, setBlog] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [allCategories, setallCategories] = React.useState([]);
  const [image, setImage] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [uploading, setUploading] = useState(false);
  
  const isFirstLoad = useRef(true);
  const token = useSelector((state) => state.token);
  useEffect(() => {
    loadCategories();
  }, []);
  useEffect(() => {
    if (blogid !== "new") loadData(blogid);
  }, [blogid]);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImage(file);
      setPreviewUrl(URL.createObjectURL(file));
    }
  };

  const handleUpload = async () => {
    if (!image) return;
    // Check if image size exceeds 500KB (500 * 1024 bytes)
    if (image.size > 500 * 1024) {
      showToastAlert('Image size should not exceed 500 KB', "error");
      return;
    }

    setUploading(true);
    try {
      const formData = new FormData();
      formData.append('banner', image);

      const response = await fetch(`${baseUrl}/api/writer/blog/upload?folder=banner`, {
        method: 'POST',
        body: formData,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const result = await response.json();
      if (result.url) {
        setPreviewUrl(result.url);
        if (result?.url) {
          setFormData((prev) => ({ ...prev, banner: result.url }));
        }
        showToastAlert('Image uploaded successfully, click update blog to update image in blog', "success");
      } else {
        showToastAlert('Upload failed', "error");
      }
    } catch (err) {
      console.error('Upload error:', err);
      alert('An error occurred during upload');
    } finally {
      setUploading(false);
    }
  };


  const loadCategories = async () => {
    try {
      const allCatArr = await getAllCategories();
      const allCats = allCatArr?.data?.items?.map((item) => item.name);
      setallCategories(allCats);
    } catch (error) {}
  };
  const loadData = async (sid) => {
    try {
      if (sid) {
        const response = await getBlogDetails(token, sid);
        if (response.status !== 200) {
          showToastAlert("Invalid blog access", "error");
          return;
        }
        setFormData({
          title: response.data.blog.title || "",
          banner: response.data.blog.banner || "",
          content: response.data.blog.content || "",
          tags: response.data.blog.tags || [],
          categories: response.data.blog.categories || [],
        });
        setPreviewUrl(response.data.blog.banner|| "");
        isFirstLoad.current = false; // ✅ Mark first load as completed
      }
    } catch (error) {}
  };

  const createCategory = () => {
    showToastAlert("Categiry Created", "success");
    loadCategories();
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleCategoryUpdate = (values) => {
    setFormData({ ...formData, categories: values });
  };

  const handleEditorChange = (type, content) => {
    //if (isFirstLoad.current) return;  // ✅ Skip update on first load
    if (formData[type] === content) return;
    setFormData((prev) => ({ ...prev, [type]: content }));
    ////setFormData({ ...formData, [type]: content });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.title || !formData.categories || !formData.content) {
      showToastAlert("All fields are mandatory.", "error");
      return;
    }
    const response = await addBlog(token, blogid, formData);
    if (response.status !== 200) {
      showToastAlert(response.data.message, "error");
      return;
    }
    navigate("/writer/blogs");
  };

  return (
    <>
      <div className="custom-form container py-3">
        <Helmet>
          <title>HeyInterns | New Blog </title>
        </Helmet>
        <Box
          className="heading-box my-5"
          sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
        >
          
          <Button
            variant="outlined"
            startIcon={<ArrowBackIcon />}
            onClick={() => navigate('/writer/blogs')}
            sx={{color:"blue", background: "yellow"}}
          >
            Go Back
          </Button>
          <Typography variant="h4">
            {blogid !== "new" ? "Update" : "Create"} Blog
          </Typography>
        </Box>
        <form>
          <div className="row  mb-4 mt-3">
            <div className="col-sm-3">
              <Typography className="input-label1">Blog title</Typography>
            </div>
            <div className="col-sm-9">
              <TextField
                placeholder="Enter your blog title"
                size="small"
                fullWidth
                name="title"
                id="fullWidth"
                onChange={handleChange}
                value={formData?.title}
              />
            </div>
          </div>
          <div className="row  mb-4">
            <div className="col-sm-3">
              <Typography className="input-label1">Choose Category</Typography>
            </div>
            <div className="col-sm-6">
              <Autocomplete
                multiple
                id="blog-category"
                options={allCategories}
                size="small"
                filterSelectedOptions
                onChange={(event, selectedOption) => {
                  handleCategoryUpdate(selectedOption);
                }}
                renderInput={(params) => (
                  <TextField placeholder="Interview Tips" {...params} />
                )}
                value={formData.categories}
              />
            </div>
            <div className="col-sm-3">
              <Button
                variant="outlined"
                fullWidth
                onClick={() => setModalOpen(true)}
                startIcon={<AddCircleOutlineOutlinedIcon />}
              >
                New Category
              </Button>
            </div>
          </div>
          <div className="row  mb-4">
            <div className="col-sm-3">
              <Typography className="input-label1">Upload Image</Typography>
            </div>
            <div className="col-sm-6">
              <input type="file" accept="image/*" onChange={handleImageChange} />
              {previewUrl && (
                <Box sx={{ mt: 2 }}>
                  <img src={previewUrl} alt="Preview" style={{ maxWidth: '30%', height: 'auto' }} />
                </Box>
              )}
              <Button
                variant="contained"
                onClick={handleUpload}
                sx={{ mt: 2 }}
                disabled={!image || uploading}
              >
                {uploading ? 'Uploading...' : 'Upload'}
               </Button>
            </div>
            <div className="col-sm-3">
            </div>
          </div>

          <div className="row  pb-4">
            <div className="col-sm-3">
              <Typography className="input-label1">Write your blog</Typography>
            </div>
            <div className="col-sm-9">
              <ReactQuill
                value={formData.content}
                onChange={(e) => handleEditorChange("content", e)}
                theme="snow"
                style={{ height: "650px", backgroundColor: "#fff" }}
              />
            </div>
          </div>
          <br />
          <br />
          <div className="my-4"></div>
          <div>
            <Button
              onClick={handleSubmit}
              type="submit"
              size="large"
              variant="contained"
              color="primary"
              fullWidth
            >
              {blogid !== "new" ? "Update" : "Submit"} Blog
            </Button>
          </div>
        </form>
        <CustomAlert />
        <CategoryModal
          open={modalOpen}
          onClose={() => setModalOpen(false)}
          onCreate={createCategory}
        />
      </div>
    </>
  );
};

export default BlogForm;
